import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=28e5b8ba&"
import script from "./DashboardHome.vue?vue&type=script&lang=ts&"
export * from "./DashboardHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports